import { render, staticRenderFns } from "./service-request-type-card.vue?vue&type=template&id=99b252f0&"
import script from "./service-request-type-card.vue?vue&type=script&lang=js&"
export * from "./service-request-type-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports